import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CountryAutoRegister } from '@services/country-auto-register/country-auto-register.service';
import { AUTO_REGISTER_STATUSES } from '@shared/meta-data';

@Component({
  selector: 'app-country-card',
  templateUrl: './country-card.component.html',
  styleUrl: './country-card.component.scss',
})
export class CountryCardComponent {
  readonly autoRegisterStatuses = AUTO_REGISTER_STATUSES;

  @Input({ required: true }) registration: CountryAutoRegister;
  @Input({ required: true }) label: string;
  @Input() type: 'danger' | 'warning' | 'success' | 'secondary' = 'secondary';

  @Output() makePayment = new EventEmitter<CountryAutoRegister>();

  get jurisdictionCode(): string {
    const { country_code, region_code } = this.registration;
    return region_code ? `${country_code}-${region_code}` : country_code;
  }
}
